import { ASSOCIAZIONE_MASSIVA_STATUS_TYPES, CausaliChoices, getTaskStatusesOneStep2Values, getTaskStatusesOneStepValues } from '../Resources/objects';
import jsonServerProvider from '../jsonProvider/digigemJsonProvider';
import { FUNCTION_URL } from '../Constants/index';
import { GET_MANY, GET_ONE } from 'ra-core';
import { checkDeviceCountPerTaskNMUs } from './helperFunctions';

let authProvider = require('../authProvider');
let clone = require('lodash.clone');

const dataProvider = jsonServerProvider(FUNCTION_URL);

/**
 * Validates each device and saves the result in validatedDevicesArray.
 * @param {array} selectedDevices The array of selected devices for association
 * @param {array} task The Task the devices will be associated to
 * @param {function} setRows The Task the devices will be associated to
 * @param {array} update A custom React Admin's crudUpdate method
 * @param {array} props React Admin's basepath and redirect
 * @return {Array} validatedDevicesArray: [{device, error}, {device, error}]
 */
export const validateDevices = async (selectedDevices, task, updateRow, translate, workrequestid, NMUQuantities, showMessage) => {
  let isCountValid = true;

  if (task.ProprietaMateriale === 'O') isCountValid = checkDeviceCountPerTaskNMUs(NMUQuantities, showMessage);

  for (let i = 0; i < selectedDevices.length; i++) {
    let device = selectedDevices[i];
    let validatedDevice = clone(device);
    let user = localStorage.getItem('username');

    if (isCountValid) {
      if (workrequestid) validatedDevice.workrequestid = workrequestid;
      if (task.Telefonico) validatedDevice.impianto = task.Telefonico
      if (task.AssegnatoA) validatedDevice.codice_impresa_name = task.AssegnatoA
      if (task.TipoTask) validatedDevice.tipo_task = task.TipoTask
      if (task.WRProdotti !== undefined) validatedDevice.wr_prodotti = task.WRProdotti
      if (task.CodProgetto) validatedDevice.cod_proj = task.CodProgetto
      if (task.TipoCliente) validatedDevice.client_type = task.TipoCliente
      if (task.ResourceId) validatedDevice.resource_id = task.ResourceId
      if (task.Causale) validatedDevice.causale = { codice: task.Causale }; //validatedDevice.causale.codice = task.Causale
      if (task.DataCompletamentoWR) validatedDevice.data_completamento_wr = task.DataCompletamentoWR
      if (task.CodiceISP) validatedDevice.codice_isp = task.CodiceISP
      task.CheckNMU ? validatedDevice.check_NMU = task.CheckNMU : validatedDevice.check_NMU = ''
      if (task.DescrizioneImpresa) validatedDevice.descrizione_impresa = task.DescrizioneImpresa
      task.ListaNMU ? validatedDevice.lista_NMU = task.ListaNMU : validatedDevice.lista_NMU = ''
      if (task.TSYS) validatedDevice.tsys = task.TSYS
      if (task.FlagOlo) validatedDevice.flag_olo = task.FlagOlo
      if (task.Area) validatedDevice.area = task.Area
      if (task.ProgettoConScarico) validatedDevice.progetto_con_scarico = task.ProgettoConScarico
      if (task.TipoNMU) validatedDevice.tipo_nmu = task.TipoNMU
      if (task.CodiceRiscontro) validatedDevice.codice_riscontro = task.CodiceRiscontro
      task.PostDelivery ? validatedDevice.post_delivery = task.PostDelivery : validatedDevice.post_delivery = ''
      if (task.BlindaScaricoMat) validatedDevice.blinda_scarico_mat = task.BlindaScaricoMat
      if (task.ProprietaMateriale) validatedDevice.proprieta_materiale = task.ProprietaMateriale
      if (task.OneStep) validatedDevice.one_step = task.OneStep
      if (task.DescTpDiagnosi) validatedDevice.desc_tp_diagnosi = task.DescTpDiagnosi
      if (task.ACLRR) validatedDevice.aclrr = task.ACLRR
      if (validatedDevice.serial_number_tim && validatedDevice.serial_number_tim.charAt(0) !== '%') {
        validatedDevice.serial_number_tim = '%' + validatedDevice.serial_number_tim;
      }

//       if (authProvider.getData().data.role !== 'administrator') {
//         //any update to status Associato or Associato_MOS
//         if (!validatedDevice.status || (validatedDevice.status.codice === '2' || validatedDevice.status.codice === '7')) {
//           validatedDevice.associated_at = new Date();
//           validatedDevice.associated_by = user;

//           let oldtask = device.workrequestid;
//           let newtask = validatedDevice.workrequestid;

//           //TO_CR_134 If the task changed (using != because one of them is string and the other an int)
//           if (oldtask === undefined || oldtask != newtask) {
//             //ES037 - If there is a reject history for that task copy the fields to the device
//             let wr_history = device.wr_history;
//             let contatoreUpdated = false;
//             if (wr_history && wr_history.length > 0) {
//               wr_history.forEach(history_entry => {
//                 if (history_entry.wr == validatedDevice.workrequestid) {
//                   validatedDevice.data_primo_reject = history_entry.wr_data_primo_reject;
//                   validatedDevice.data_ultimo_reject = history_entry.wr_data_ultimo_reject;
//                   validatedDevice.contatore = history_entry.wr_contatore;
//                   contatoreUpdated = true;
//                 }
//               })
//             }

//             //ES037 - If the task changed (using != because one of them is string and the other an int) and that association has been rejected, log it to wr_history
//             let contatore = device.contatore;
//             if (contatore) {
//               //we need to clear contatore, data_primo_reject, data_ultimo_reject unless it has been set above from the new task
//               if (!contatoreUpdated) {
//                 delete validatedDevice.contatore;
//                 delete validatedDevice.data_primo_reject;
//                 delete validatedDevice.data_ultimo_reject;
//                 if (validatedDevice.$unset) {
//                   validatedDevice.$unset.contatore = "";
//                   validatedDevice.$unset.data_primo_reject = "";
//                   validatedDevice.$unset.data_ultimo_reject = "";
//                 }
//                 else {
//                   validatedDevice['$unset'] = { contatore: "", data_primo_reject: "", data_ultimo_reject: "" };
//                 }
//               }

//               if (wr_history) {
//                 validatedDevice.wr_history = wr_history;
//                 let found_wr = false;

//                 for (let i = 0; i < wr_history.length; i++) {
//                   if (wr_history[i].wr === oldtask) {
//                     found_wr = true;
//                     validatedDevice.wr_history[i].wr_data_ultimo_reject = device.data_ultimo_reject;
//                     validatedDevice.wr_history[i].wr_contatore = contatore;
//                   }
//                 }

//                 if (!found_wr) {
//                   validatedDevice.wr_history.push({
//                     wr: oldtask,
//                     wr_data_primo_reject: device.data_primo_reject,
//                     wr_data_ultimo_reject: device.data_ultimo_reject,
//                     wr_contatore: contatore
//                   })
//                 }
//               }
//               else {
//                 validatedDevice.wr_history = [{
//                   wr: oldtask,
//                   wr_data_primo_reject: device.data_primo_reject,
//                   wr_data_ultimo_reject: device.data_ultimo_reject,
//                   wr_contatore: contatore
//                 }]
//               }
//             }
//           }
//         }
//       }

      //CR80
      if (!validatedDevice._id) {
        validatedDevice.tipo_inserimento = 'Digitato';
      }

      else if (validatedDevice.status && (validatedDevice.status.codice === '2' || validatedDevice.status.codice === '7')) {
        validatedDevice.tipo_inserimento = 'DaLista';
      }

      //CR92
      let devicesScaricato = await dataProvider(GET_MANY, 'devicesScaricato', { "filter": { workrequestid: validatedDevice.workrequestid, cod_terr_sap: 'GetAll' } })
        .then(
          scaricatoresponse => {
            return scaricatoresponse.total ? scaricatoresponse : undefined;
          })
        .catch(error => {
          console.log(error);
          return undefined;
        });
      let devices = await dataProvider(GET_MANY, 'devices', { "filter": { workrequestid: validatedDevice.workrequestid, cod_terr_sap: 'GetAll' } })
        .then(
          async response => {
            return response.total ? response : undefined;
          })
        .catch(error => {
          console.log(error);
          return undefined;
        });

      if (devicesScaricato) {
        if (devices) {
          devices.total = devices.total + devicesScaricato.total;
          devices.data = [...devices.data, ...devicesScaricato.data];
        }
        else {
          devices = devicesScaricato;
        }
      }

      let CR138Exceptions = await dataProvider(GET_ONE, 'settings', { name: 'CR138Exceptions' });
      let nmuExclusions = CR138Exceptions.data.value;

      let [isSuperWIFI, maxQuantita, superWifiNMUs, famigliaSuperWifiNMUs] = await checkSuperWifi(validatedDevice, dataProvider);
      let isMaxQuantitaExceeded = maxQuantitaExceeded(devices, famigliaSuperWifiNMUs, maxQuantita);

      let otherSN = '';
      if (devices) {
        devices.data.forEach(d => {
          if (d.serial_number_tim !== validatedDevice.serial_number_tim) {
            if (d.anomalia && d.anomalia.codice === "8" || superWifiNMUs.includes(d.cod_nmu)) { }
            else if (d.status && d.status.descrizione) {
              otherSN = otherSN + ' ' + d.serial_number_tim + ', ' + d.status.descrizione + ';';
            }
          }
        })
      }

      if (validatedDevice.codice_impresa_name !== authProvider.getData().data.company) {
        updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.ERROR, translate('tim.associazioneMassiva.caso6'));
        continue;
      }

      if (((!validatedDevice.reverse || (validatedDevice.reverse && validatedDevice.reverse.codice !== '1')) &&
        isSuperWIFI && isMaxQuantitaExceeded)) {
        updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.ERROR, translate('tim.associazioneMassiva.superWifi'));
        continue;
      }
      else if ((!validatedDevice.reverse || (validatedDevice.reverse && validatedDevice.reverse.codice !== '1')) &&
        !isSuperWIFI && otherSN !== '') {
        updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.ERROR, translate('tim.associazioneMassiva.caso5', { list: otherSN }));
        continue;
      }
      //Validate only if the update is to Associato/Associato_MOS and it's not an Administrator
      else if (['2', '7'].includes(validatedDevice.status.codice) && authProvider.getData().data.role !== 'administrator') {
        if (validatedDevice.causale) {
          if (validatedDevice.causale.codice === '999') {
            validatedDevice.causale.codice = '930';
            //validated_values.anomalia = { codice: '14' };
            //TO_SM_184 - validated_values.status = { codice: '2' };
          }
          else {
            CausaliChoices.forEach(function (c) {
              if (c.id === validatedDevice.causale.codice)
                validatedDevice.causale.codice = c.id;
            })
          }
        }
        //CR50 - Check if it's a device for user impresa but not for a cod_terr_sap from his list
        let imp_cts = localStorage.getItem('impresa_cod_terr_sap');
        imp_cts = (!imp_cts || imp_cts === "") ? [] : JSON.parse(imp_cts);
        let cts = localStorage.getItem('cod_terr_sap');
        cts = (!cts || cts === "") ? [] : JSON.parse(cts);

        let isImpresaDevice = false;
        if (imp_cts.includes(validatedDevice.cod_terr_sap) && !cts.includes(validatedDevice.cod_terr_sap)) {
          isImpresaDevice = true;
        }

        //CR138
        if (validatedDevice.tipo_task === 'DELIVERY' && validatedDevice.cod_stato_uso && validatedDevice.cod_stato_uso.codice === '3' && !nmuExclusions.includes(validatedDevice.cod_nmu)) {
          updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.ERROR, translate('tim.associazioneMassiva.cr138'));
          continue;
        }
        else {
          let anom = false;
          //[REQ018 - CASO3]
          let impresaMatch = function () {
            let user_cod_terr_sap = localStorage.getItem('cod_terr_sap');
            if (user_cod_terr_sap) {
              let foundSameImpresa = function (element) {
                return element === validatedDevice.cod_terr_sap;
              }

              if (JSON.parse(user_cod_terr_sap).some(foundSameImpresa))
                return true;
            }
            return false;
          }
          if (!isImpresaDevice && !impresaMatch()) {
            anom = true;
            updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.ERROR, translate('tim.associazioneMassiva.caso3'));
            continue;
          }
           else {
            //REVERSE 
            if (!anom && validatedDevice.reverse && validatedDevice.reverse.codice === '1') {
              validatedDevice.newStatus = { codice: '0' };
              validatedDevice.anomalia = { codice: '8' };
              anom = true;
              updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.WARNING, translate('tim.associazioneMassiva.reverse'));
              continue;
            }
            //If it's a device for his impresa but not for the cod_terr_sap he has access, just show a warning
            if (!anom && isImpresaDevice) {
              updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.WARNING, translate('tim.associazioneMassiva.cr50'));
              continue;
            }

            //CR93 - Show a warnign depending on check_NMU
            if (!anom && validatedDevice.check_NMU) {
              if (validatedDevice.check_NMU === 'WR SENZA CONSEGNA PRODOTTI' && (!validatedDevice.progetto_con_scarico || validatedDevice.progetto_con_scarico != 'SI')) {
                updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.WARNING, translate('tim.associazioneMassiva.cr93_senza_consegna'));
                continue;
              }
              else if (validatedDevice.check_NMU === 'ROUTER LIBERO') {
                updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.WARNING, translate('tim.associazioneMassiva.cr93_libero'));
                continue;
              }
              else if (validatedDevice.check_NMU === 'NMU NON COMPATIBILE' || validatedDevice.check_NMU === 'FAMIGLIA NMU NON PREVISTA') {
                updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.WARNING, translate('tim.associazioneMassiva.cr93_non_comp'));
                continue;
              }
            }
           }
         }
      }

      //O - WR OLO ONE STEP Delivery con materiale OLO oppure WR OLO ONE STEP Assurance di tipo PostDelivery  con materiale OLO
      //OA - WR OLO ONE STEP Assurance  con materiale OLO, si tratta di Assurance Standard
      //Null - WR non OLO, WR OLO non ONE STEP, WR OLO ONE STEP con materaile TIM
      //CR_173 2.2.1.1.	Passaggio di Stato Attribuito -> Scaricato (WR OLO One STEP con materiale OLO Delivery)
      //CR_173 2.2.1.2.	Passaggio di Stato Attribuito -> In Attesa di Scarico (WR OLO One STEP con materiale OLO Delivery)
      if (task.Status === 'Completata' && task.CausaleTask === 'COMPLWR' && task.BlindaScaricoMat === 'SI') {
        validatedDevice.sendToSap = true;
        validatedDevice.associated_at = new Date();
        validatedDevice.associated_by = user;
        validatedDevice.approved_at = new Date();
        validatedDevice.approved_by = user;
      }
      //CR_173 2.2.1.3.	Passaggio di Stato Attribuito -> Da Scaricare
      else if (task.Status !== 'Completata') {
        validatedDevice.newStatus = { codice: '12', descrizione: 'Da Scaricare' }; //DA SCARICARE
        validatedDevice.associated_at = new Date();
        validatedDevice.associated_by = user;
      }

      if ((getTaskStatusesOneStep2Values().includes(task.Status))
        || (task.Status === 'Completata' && task.CausaleTask !== 'COMPLWR')
        || (task.Status === 'Completata' && task.CausaleTask === 'COMPLWR' && task.BlindaScaricoMat !== 'SI')) {
        updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.ERROR, translate('tim.associazioneMassiva.TO_SM_319'));
        continue;
      }

      //CR_173 2.2.2.9.1 - Nuovo Check su associazione multiple 
      let cod_nmu = validatedDevice.cod_nmu;
      let NMUGestitoFilter = await dataProvider(GET_ONE, 'settings', { name: 'NMUGestitoFilter' });
      let filter = NMUGestitoFilter.data.value;
      filter['cod_nmu'] = cod_nmu;
      let nomenclatore = await dataProvider(GET_MANY, 'nomenclatores', { "filter": filter })
        .then(
          response => {
            return response.total ? response.data[0] : undefined;
          })
        .catch(error => {
          console.log(error);
          return undefined;
        });
      if (!['O', 'OA'].includes(task.ProprietaMateriale) || !['ZRES', 'ZES0', 'ZEST'].includes(nomenclatore.divresp)) {
        updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.ERROR, translate('tim.associazioneMassiva.cr173_invalidWRType'));
        continue;
      }

      //CR_173 2.2.2.9.3 - Nuovo Stato sulla WorkRequest ONE-STEP con materaile OLO
      if (['O', 'OA'].includes(task.ProprietaMateriale)) {
        if (getTaskStatusesOneStepValues().includes(task.Status) || (task.Status === "Completato" && task.CausaleTask !== "COMPLWR")
          || (task.Status === "Completato" && task.CausaleTask === "COMPLWR" && (task.BlindaScaricoMat === null || typeof task.BlindaScaricoMat === 'undefined'))) {
          updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.ERROR, translate('tim.associazioneMassiva.cr173_invalidWRStatus'));
          continue;
        }
      }

      //CR_173 2.2.2.9.5 - Nuovo Check su provenienza magazzini omogenea
      //comparing with the first device to avoid looping over all devices multiple times. If one of them is different eventually it will fail
      if ((!device.cod_terr_sap.startsWith("IB") && selectedDevices[0].cod_terr_sap.startsWith("IB"))
        || (device.cod_terr_sap.startsWith("IB") && !selectedDevices[0].cod_terr_sap.startsWith("IB"))) {
        updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.ERROR, translate('tim.associazioneMassiva.cr173_MagazziniOmogenea'));
        continue;
      }

      //CR_173 2.2.2.9.10 - Nuovo Check sulle quantità complessive

    // if (!hasErrors)
      updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.SUCCESS);
    }
    else {
      updateRow(validatedDevice, ASSOCIAZIONE_MASSIVA_STATUS_TYPES.ERROR);
    }
  }

  return;
}


//Offerta Calcio
async function checkSuperWifi(validated_values, dataProvider) {
  let isSuperWIFI = false;
  let famiglia = null;
  let maxQuantita = 0;
  let superWifiNMUs = {
    decoder: [],
    repeater: [],
    altro: []
  };
  let famigliaNMUs = [];
  let allSuperWifiNMUs = [];
  let superWifiNomenclatores = await dataProvider(GET_MANY, 'nomenclatores', { "filter": { tipo_famiglia: { $in: ["Repeater", "Decoder", "Altro"] } } })
    .then(
      response => {
        return response.total ? response : undefined;
      })
    .catch(error => {
      console.log(error);
      return undefined;
    });
  if (superWifiNomenclatores && superWifiNomenclatores.total > 0) {
    superWifiNomenclatores.data.forEach(n => {
      allSuperWifiNMUs.push(n.cod_nmu)
      switch (n.tipo_famiglia) {
        case 'Repeater':
          superWifiNMUs.repeater.push(n.cod_nmu);
          break;
        case 'Decoder':
          superWifiNMUs.decoder.push(n.cod_nmu);
          break;
        case 'Altro':
          superWifiNMUs.altro.push(n.cod_nmu);
          break;
        default:
          break;
      }
      //n.tipo_famiglia == 'Repeater' ? superWifiNMUs.repeater.push(n.cod_nmu) : superWifiNMUs.decoder.push(n.cod_nmu);
      if (n.cod_nmu === parseInt(!validated_values._id ? validated_values.serial_number_tim.substring(5, 11) : validated_values.cod_nmu)) {
        famiglia = n.tipo_famiglia;
        maxQuantita = n.max_quantita;
        isSuperWIFI = true;
      }
    })
  }
  if (famiglia) {
    switch (famiglia) {
      case 'Repeater':
        famigliaNMUs = superWifiNMUs.repeater;
        break;
      case 'Decoder':
        famigliaNMUs = superWifiNMUs.decoder;
        break;
      case 'Altro':
        famigliaNMUs = superWifiNMUs.altro;
        break;
      default:
        break;
    }
  }
  return [isSuperWIFI, maxQuantita, allSuperWifiNMUs, famigliaNMUs];
}


function maxQuantitaExceeded(devices, superWifiNMUs, maxQuantita) {
  //let includesSelf = false;
  let existingSuperWifi = 0;
  if (devices) {
    devices.data.forEach(d => {
      if (superWifiNMUs.includes(d.cod_nmu)) existingSuperWifi++;
      //if (d.serial_number_tim === validated_values.serial_number_tim && d.workrequestid === validated_values.workrequestid) includesSelf = true;
    })
  }
  //return includesSelf ? false : existingSuperWifi + 1 > maxQuantita;
  return existingSuperWifi + 1 > maxQuantita;
}
